import { Link } from "@tanstack/react-router";
import type { JSX } from "react";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const NotFoundPage = (): JSX.Element => (
  <div className="grid flex-1 place-items-center px-6 py-20 text-center">
    <div>
      <p className="font-mono text-sm font-semibold text-muted-foreground">404</p>
      <h1 className="mt-2 text-2xl font-bold tracking-tight">Nothing here</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        That page does not exist. A clip link looks like{" "}
        <code className="text-[0.85em]">openvod.app/v?p=…&amp;c=…</code>
      </p>
      <Link to="/" className={cn(buttonVariants({ variant: "outline", size: "sm" }), "mt-6")}>
        Go home
      </Link>
    </div>
  </div>
);
